import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { cardClose, cardToggle } from './card-animation';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  animations: [cardToggle, cardClose],
  encapsulation: ViewEncapsulation.None
})
export class CardComponent implements OnInit {
  @Input() headerContent: string;
  @Input() title: string;
  @Input() blockClass: string;
  @Input() cardClass: string;
  @Input() classHeader: boolean = false;
  @Input() showRefresh: boolean = true;
  @Input() showClose: boolean = true;
  @Input() startCollapsed: boolean = true;

  cardToggle: string = 'expanded';
  cardClose: string = 'open';

  ngOnInit() {
    if (this.startCollapsed) {
      this.cardToggle = 'collapsed';
    }
  }

  toggleCard() {
    this.cardToggle = this.cardToggle === 'collapsed' ? 'expanded' : 'collapsed';
  }

  closeCard() {
    this.cardClose = this.cardClose === 'closed' ? 'open' : 'closed';
  }
}
